import axios from "../axios";

export const fetchArtists = (payload) => {
  return axios.post("/users/artists", payload);
};

export const fetchArtistById = (id) => {
  return axios.get(`/users/artists/${id}`);
};
